import ImpressionDivWrapper from '@/components/Common/ImpressionDivWrapper';
import { getSVG } from '@/components/Common/styles/mixins';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import React, { FC, useCallback, useContext } from 'react';

import styles from './index.module.scss';

const Tips: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  const getResourcePath = useCallback((path: string): string => getSVG(`/static/images/nol-promotion/v30/${path}`), []);

  return (
    <ImpressionDivWrapper
      logData={{
        pageName: store.pageName,
        objectContainer: '놀수록 놀라운 NOL 카드',
        motherPageVersion: store.version,
        motherPageSectionType: '',
        motherPageSectionName: '놀수록 놀라운 NOL 카드',
      }}
    >
      <div className={styles.container}>
        <div className={styles.supTitle}>NOL 카드 할인 Tip</div>
        <div className={styles.title}>
          놀수록 놀라운 <br />
          NOL 카드
        </div>
        <div className={styles.card}>
          <div className={styles.cardTitle}>
            NOL에서 국내 여행을 즐긴다면
            <br />첫 6개월간 최대 <span className={styles.blue}>31만원 상당 혜택</span>
          </div>
          <div>
            <img className={styles.receipt} src={getResourcePath('img_receipt_01.png')} alt="" />
          </div>
        </div>
      </div>
    </ImpressionDivWrapper>
  );
};

export default observer(Tips);
